import type { InferProps } from 'prop-types';
import type { ComponentClass } from 'react';

import Err, { type propTypes } from './Err';

export default Err as ComponentClass<InferProps<typeof propTypes>>;
